export default __webpack_public_path__ + "static/media/3_active.144f896c.png";